import request from '@/utils/request'

// 角色列表
export async function apiGetRoleTableList(params) {
  return request({
    url: '/hhxc-admin/api/v1/role/list',
    method: 'get',
    params,
  })
}

// 角色列表
export async function apiGetRoleTableListAll(params) {
  return request({
    url: '/hhxc-admin/api/v1/role',
    method: 'get',
    params,
  })
}

// 新增角色角色
export async function apiAddRole(data) {
  return request({
    url: '/hhxc-admin/api/v1/role',
    method: 'post',
    data,
  })
}

// 编辑角色
export async function apiEditorRole(params) {
  const { id } = params
  delete params.is
  return request({
    url: `/hhxc-admin/api/v1/role/${id}`,
    method: 'PUT',
    data: params,
  })
}

// 删除角色
export async function apiDeleteRole(params) {
  return request({
    url: `/hhxc-admin/api/v1/role/${params.id}`,
    method: 'DELETE',
  })
}

// 个人信息
export async function apiUserInfo(id) {
  return request({
    url: `/hhxc-admin/api/v1/user/${id}`,
    method: 'get',
  })
}
